
<template>
  <div :class="{ 'wrapper': isSelected }">
    <div :class="`number ${customClass} ${isSelected ? 'number__selected' : ''}`"
      :style="{ 'background-color': bgColor }" @click="selectBall">
      <span>{{ number }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: [Number, String],
      required: true,
    },
    customClass: {
      type: String,
      default: "default",
    },
    bgColor: {
      type: String,
      default: "#FEDB00",
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectBall() {
      this.$emit('selectBall')
    }
  }
}
</script>

<style lang="scss">
@import "@/public/scss/common/_number.scss";
</style>
  